"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ERRORS_WORDINGS = {
    DEFAULT: 'Une erreur est survenue, veuillez réessayer plus tard.',
};
exports.default = ERRORS_WORDINGS;
//# sourceMappingURL=Errors.js.map